import { Field as BaseField } from '@base-ui/react/field';
import { styled } from '../lib/styled.tsx';
import { controlSurface, fieldError, fieldHint, fieldLabel } from '../lib/surfaces.ts';

/**
 * The labelling and validation frame every control can sit in.
 *
 * Kept as parts rather than flattened: a field's shape is the thing that varies
 * between forms — label beside the control, description below it, error only
 * after submit — and {@link TextField} already covers the common arrangement.
 */
export const Field = {
  Root: styled(BaseField.Root, 'flex flex-col gap-1.5'),
  Label: styled(
    BaseField.Label,
    // inline-flex so a label can hold its own control — the checkbox/radio
    // pattern — without every other label needing a wrapper.
    //
    // A label that *contains* its control is an option's name, not a field's,
    // and Vendy sets those in ordinary body text: the bold 15px belongs to the
    // thing above an input, not to the word beside a radio. Each of those
    // controls renders a hidden `input` inside the label for form
    // participation — a text field's input is its *sibling* — so `has-[input]`
    // is what tells the two apart. (Not `has-[button]`: Base UI renders a
    // radio as a span.)
    `inline-flex items-center gap-2 ${fieldLabel} has-[input]:text-bodysm has-[input]:font-normal`,
  ),
  Control: styled(BaseField.Control, controlSurface),
  Description: styled(BaseField.Description, fieldHint),
  Item: styled(BaseField.Item, 'flex items-start gap-2'),
  Error: styled(BaseField.Error, fieldError),
  /** Render-prop only: reads validity state, owns no markup of its own. */
  Validity: BaseField.Validity,
};
